import React from "react";
import styles from "./index.module.scss";
import Logo from "@src/components/Logo";
import { useNavigate } from "react-router-dom";
import Button from "@src/components/Button";
import img from "./assets/img.png";
import { isAndroid, isIOS, isIpad } from "@src/lib/utils";
const title = "Get the Primus app to verify your data";

export default () => {
  const navigate = useNavigate();
  const onLogoClick = () => {
    navigate("/");
  };
  const onClickInstall = () => {
    let installLink = "";
    if (isAndroid()) {
      installLink =
        "https://play.google.com/store/apps/details?id=xyz.primuslabs.primusapp";
    } else if (isIOS() || isIpad()) {
      installLink = "https://apps.apple.com/app/primus/id6745027077";
    }
    window.open(installLink);
  };
  return (
    <div className={styles.root}>
      <div className={styles.container}>
        <div className={styles.wrapper}>
          <div className={styles.logoWrapper}>
            <Logo
              onClick={onLogoClick}
              fontColor={"#FD4C00"}
              iconColor={"#fff"}
            />
          </div>

          <h1 className={styles.title}>{title}</h1>
          <Button className={styles.button} isDark onClick={onClickInstall}>
            Install Now
          </Button>
          <img className={styles.img} src={img} alt="Primus app" />
        </div>
      </div>
    </div>
  );
};
